import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { AuthContext } from "../../context/AuthContext";
import JobItem from "../../component/JobItem";
import {VerticalMode} from "../Home/AutoPlay";
import { RelatedJobsCard } from "../Home/JobsList";
import { generateRandomString } from "../../Utility/Utility";
import moment from "moment";
import { useSnackbar } from "notistack";
import EmailApplyModal from "./EmailApplyModal";

// Debounce utility function
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export default function jobsDetails(props) {
  const sliderRef = useRef(null);
  const [jobsDetail, setJobsDetail] = useState([]);
  const [jobSkills, setJobSkills] = useState([]);
  const [sameCompanyJobs, setSameCompanyJobs] = useState([]);
  const [similarjobs, setSimilarJobs] = useState([]);
  const [hasApplied, setHasApplied] = useState(false);
  const [hasSaved, setHasSaved] = useState(false);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const [applying, setApplying] = useState(false);
  const [saving, setSaving] = useState(false);
  const DESCRIPTION_CHAR_LIMIT = 840;
  // const id = props.match.params.id;
  const slug = props.match.params.slug;
  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated, userType } = useContext(AuthContext);
  useEffect(() => {
    
    let isMounted = true;
    const controller = new AbortController();
    
    window.scrollTo(0, 0);
    
    axios.post("api/get_jobs_detail", { slug: slug }, { signal: controller.signal }).then((res) => {
      if (!isMounted) return;
      if (res.data.status == "success") {
        setJobsDetail(res.data.data[0]);
        setJobSkills(res.data.data[0].jobskills);
        setSameCompanyJobs(res.data.samecompanyjobs);
        setSimilarJobs(res.data.similarjobs);
        setHasApplied(res.data.hasApplied);
        setHasSaved(res.data.hasSaved);
      } else {
        setJobsDetail([]);
        setJobSkills([]);
        setSameCompanyJobs([]);
        setSimilarJobs([]);
      }
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError" && error.name !== "CanceledError") {
        console.error("Failed to load job details:", error);
      }
    });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [slug]);

    useEffect(() => {
      console.log("[VerticalSlick] Component mounted, testimonials count:", similarjobs.length);
      
      // Add small delay to ensure Slick is fully initialized
      const timer = setTimeout(() => {
        if (sliderRef.current) {
          console.log("[VerticalSlick] Slider ref available:", sliderRef.current);
          console.log("[VerticalSlick] Slider initialized and ready");
        }
      }, 300);
  
      return () => clearTimeout(timer);
    }, [similarjobs]);

    // useEffect to attach wheel listener with passive: false
    useEffect(() => {
      const relatedJobsDiv = document.querySelector('.related_jobs');
      
      if (!relatedJobsDiv) {
        console.log("[VerticalSlick] related_jobs div not found");
        return;
      }

      const handleWheelWithPreventDefault = (e) => {
        console.log("[VerticalSlick] Wheel event on related_jobs div, deltaY:", e.deltaY);
        e.preventDefault(); // This now works because passive: false
        debouncedHandleWheel(e.deltaY);
      };

      // Use addEventListener with passive: false to allow preventDefault
      relatedJobsDiv.addEventListener('wheel', handleWheelWithPreventDefault, { passive: false });

      return () => {
        relatedJobsDiv.removeEventListener('wheel', handleWheelWithPreventDefault);
        console.log("[VerticalSlick] Wheel event listener removed");
      };
    }, [debouncedHandleWheel]);
    
    const handlePrevClick = () => {
    console.log("[VerticalSlick] Previous button clicked");
    try {
      if (sliderRef.current) {
        console.log("[VerticalSlick] Calling slickPrev()");
        sliderRef.current.slickPrev();
        console.log("[VerticalSlick] slickPrev() executed");
      } else {
        console.error("[VerticalSlick] ERROR: sliderRef.current is null!");
      }
    } catch (error) {
      console.error("[VerticalSlick] ERROR in handlePrevClick:", error);
    }
  };

  const handleNextClick = () => {
    console.log("[VerticalSlick] Next button clicked");
    try {
      if (sliderRef.current) {
        console.log("[VerticalSlick] Calling slickNext()");
        sliderRef.current.slickNext();
        console.log("[VerticalSlick] slickNext() executed");
      } else {
        console.error("[VerticalSlick] ERROR: sliderRef.current is null!");
      }
    } catch (error) {
      console.error("[VerticalSlick] ERROR in handleNextClick:", error);
    }
  };

  // Debounced wheel handler - accepts deltaY as parameter
  const debouncedHandleWheel = debounce((deltaY) => {
    console.log("[VerticalSlick] Debounced wheel handler triggered, deltaY:", deltaY);
    try {
      if (!sliderRef.current) {
        console.error("[VerticalSlick] ERROR: sliderRef.current is null!");
        return;
      }
      
      if (deltaY > 0) {
        console.log("[VerticalSlick] Scrolling DOWN - calling slickNext()");
        sliderRef.current.slickNext();
      } else if (deltaY < 0) {
        console.log("[VerticalSlick] Scrolling UP - calling slickPrev()");
        sliderRef.current.slickPrev();
      }
    } catch (error) {
      console.error("[VerticalSlick] ERROR in debouncedHandleWheel:", error);
    }
  }, 300); // 300ms debounce delay

  // Extract deltaY immediately before event is pooled
  const handleWheel = (e) => {
    console.log("[VerticalSlick] Wheel event detected, deltaY:", e.deltaY);
    e.preventDefault();
    debouncedHandleWheel(e.deltaY);
  };

  const salaryText = () => {
    if (jobsDetail.salary_type === "R" && jobsDetail.minsalary)
      return `${jobsDetail.jobsDetailscur} ${jobsDetail.minsalary}–${jobsDetail.maxsalary} / ${jobsDetail.salary_unit}`;
    if (jobsDetail.salary_type === "F" && jobsDetail.minsalary)
      return `${jobsDetail.jobsDetailscur} ${jobsDetail.minsalary} / ${jobsDetail.salary_unit}`;
    return "Negotiable";
  };

  const ExperienceText = () => {
    if (jobsDetail.experience_type === "F") return "Freshers";
    if (jobsDetail.experience_type === "E") {
      const minExp = jobsDetail.min_exp ? `${jobsDetail.min_exp} ${jobsDetail.min_exp_unit || "years"}` : "";
      const maxExp = jobsDetail.max_exp ? `${jobsDetail.max_exp} ${jobsDetail.exp_unit || "years"}` : "";
      if (minExp && maxExp) {
        return `${minExp} - ${maxExp}`;
      }else if (minExp) {        return `${minExp}+`;
      } else if (maxExp) {
        return `Up to ${maxExp}`;
      }
      return  "Experienced";
    }
    return "Not Specified";
  }

    const ExpiryText = () => {
    if (jobsDetail.expiry_data === "Expired") {
      return <div className="text-danger">Job Expired</div>;
    }
    else {      return `${jobsDetail.apply_before} (${jobsDetail.expiry_data} left)`;
    }
  }

  const getBreakpointSettings = (maxSlidesForScreen) => {
      // 1. Cap it at the maximum allowed for this screen size or total jobs
      let computedSlides = Math.min(similarjobs.length, maxSlidesForScreen) || 1;

      // 2. Apply your forced-scroll deduction rule
      if (similarjobs.length > 1 && similarjobs.length <= maxSlidesForScreen) {
        computedSlides = similarjobs.length - 1;
      }

      const shouldScroll = similarjobs.length > computedSlides;

      return {
        slidesToShow: computedSlides,
        infinite: shouldScroll,
        // autoplay: shouldScroll,
      };
    };
  
    const desktopSettings = getBreakpointSettings(5);

   const vsettings = {
    dots: false,
    // infinite: true,
    speed: 500,
    // slidesToShow: 5,

    slidesToShow: desktopSettings.slidesToShow,
    infinite: desktopSettings.infinite,
    
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    adaptiveHeight: false,
    lazyLoad: false,
    touchMove: true,
    swipeToSlide: true,
    beforeChange: (oldIndex, newIndex) => {
      console.log("[VerticalSlick] Carousel changing from index", oldIndex, "to", newIndex);
    },
    afterChange: (currentIndex) => {
      console.log("[VerticalSlick] Carousel changed to index", currentIndex);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          // slidesToShow: 4,
          ...getBreakpointSettings(4),
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          // slidesToShow: 3,
          ...getBreakpointSettings(3),
          slidesToScroll: 1,
        }
      }
    ]
  };

  const handleJobApply = () => {
    setApplying(true);
    axios.post("api/seeker/apply_job", { id: jobsDetail.id }).then((resp) => {
      if (resp.data.status == "success") {
        setHasApplied(true);
        enqueueSnackbar(resp.data.message, { variant: "success" });
      } else {
        setHasApplied(false);
        enqueueSnackbar(resp.data.message, { variant: "error" });
      }
    }).finally(() => {
      setApplying(false);
    });
  };

  const handleJobSave = () => {
    setSaving(true);
    axios.post("api/seeker/save_job", { id: jobsDetail.id }).then((resp) => {
      if (resp.data.status == "success") {
        setHasSaved(true);
        enqueueSnackbar(resp.data.message, { variant: "success" });
      } else {
        setHasSaved(false);
        enqueueSnackbar(resp.data.message, { variant: "error" });
      }
    }).finally(() => {
      setSaving(false);
    });
  };

  const socialPlatforms = [
    { key: 'facebook',  icon: 'ri-facebook-circle-fill', label: 'Facebook' },
    { key: 'instagram', icon: 'ri-instagram-line',       label: 'Instagram' },
    { key: 'linkedin',  icon: 'ri-linkedin-box-fill',    label: 'LinkedIn' },
    { key: 'google',    icon: 'ri-google-fill',          label: 'Google' },
    { key: 'twitter',   icon: 'ri-twitter-x-fill',       label: 'Twitter' },
    { key: 'youtube',   icon: 'ri-youtube-fill',         label: 'Youtube' },
    { key: 'tiktok',    icon: 'ri-tiktok-fill',          label: 'TikTok' },
    { key: 'whatsapp',  icon: 'ri-whatsapp-line',        label: 'WhatsApp' },
    { key: 'viber',     icon: 'viber-svg',               label: 'Viber' },
  ];

  useEffect(() => {
    const originalTitle = document.title;

    const companyName = jobsDetail.comp_name || jobsDetail.newspaper_name || '';
    if (jobsDetail.job_title) {
      document.title = `${jobsDetail.job_title} Job In Nepal-${companyName} | solidfuture`;
    }

    return () => {
      document.title = originalTitle;
    };
  }, [jobsDetail.job_title, jobsDetail.comp_name, jobsDetail.newspaper_name]);

  return (
    <div className="section-full p-t120  p-b60 site-bg-light">
      <div className="container">

        <div className="twm-job-self-info">
          <div className="twm-job-self-top">
            <div className="twm-media-bg">

              <div class="job-view">
                <span><i class="ri-eye-line"></i> {jobsDetail.views}</span>
              </div>

                {jobsDetail.imgUrl != null ? (
                    <div className="twm-media">
                      <img
                        src={jobsDetail.imgUrl}
                        alt={jobsDetail.job_title}
                      />
                    </div>
                  ) : (
                    ""
                )}

                <div className="company_name_dtl">
                  <Link to={`/company/${jobsDetail.clientslug}`}>
                    {jobsDetail.comp_name}
                  </Link>
                </div>

                <div className="job_title_share">
                  {jobsDetail.job_title != "" ? (
                      <h4 className="twm-job-title">
                        {jobsDetail.job_title}
                      </h4>
                    ) : (
                    ""
                  )}

                  <div className="social_share">
                    <h4 className="twm-s-title">Social Media Links</h4>
                    <div className="twm-social-tags">
                      {socialPlatforms.map((platform) => {
                        const url = jobsDetail[platform.key];
                        if (!url) return null;

                        return (
                          <a
                            key={platform.key}
                            className="fb-clr"
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {platform.icon === 'viber-svg' ? (
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" fill="currentColor">
                                <path d="M444.3 49.9c-12.7-11.7-64.1-49-178.7-49.5 0 0-135.1-8.1-200.9 52.3-36.6 36.6-49.5 90.3-50.9 156.8s-3.1 191.1 117 224.9l.1 0-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM458.2 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9 .4-85.7 .4-85.7l0 0C43.4 372.7 49.4 266.6 50.5 211.1s11.6-101 42.6-131.6c55.7-50.5 170.4-43 170.4-43 96.9 .4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9 .6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4 .7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5 .9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9 .1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7 .5 133 51.4 133.7 139.2zM375.2 329l0 .2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8l.2 0c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1 .8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"/>
                              </svg>
                            ) : (
                              <i className={platform.icon}></i>
                            )}
                          </a>
                        );
                      })}
                    </div>
                  </div>


                </div>

                  

              {/* <img
                src={jobsDetail.jobcoverimgUrl}
                alt={jobsDetail.job_title}
              /> */}
              
              {/* {jobsDetail.work_type != null ? (
                  <div className="twm-jobs-category">
                    <span className="twm-bg-purple">
                      {jobsDetail.work_type}
                    </span>
                  </div>
                ) : (
                  ""
              )} */}

            </div>
            <div className="company_desc">
              <h4>Company Description</h4>
              {jobsDetail.company_description != null ? ( 
                <>
                  <div>
                    {isDescriptionExpanded 
                      ? ReactHtmlParser(jobsDetail.company_description)
                      : ReactHtmlParser(jobsDetail.company_description.substring(0, DESCRIPTION_CHAR_LIMIT) + "...")
                    }
                  </div>
                  
                  {jobsDetail.company_description.length > DESCRIPTION_CHAR_LIMIT && (
                    <button 
                      onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
                      className="btn btn-sm btn-readmore"
                    >
                      {isDescriptionExpanded ? "Read Less" : "Read More"}
                    </button>
                  )}
                </>
              ) : ( 
                <p>No description available.</p>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-8 col-lg-8 col-md-12">
            <div className="cabdidate-de-info">
              <div className="twm-job-self-wrap">

                <div className="twm-mid-content short_jobs_info">
                  {/* <span className="twm-job-post-duration">
                        / {moment(jobsDetail.created_at).fromNow()}
                      </span> */}
                  <div className="grid">

                    {jobsDetail.no_of_vacancy != "" ? (
                        <div className="flex flex-col md:flex-row justify-between">
                          <span> No. of Openings:</span>
                          <span>{jobsDetail.no_of_vacancy}</span>
                        </div>
                      ) : (
                        ""
                    )}

                    {jobsDetail.job_location != "" ? (
                          <div className="flex flex-col md:flex-row justify-between">
                            <span>Job Location</span>
                            <span>{jobsDetail.job_location}</span>
                          </div>
                        ) : (
                          ""
                      )}

                      {jobsDetail.min_exp != "" ? (
                            <div className="flex flex-col md:flex-row justify-between">
                              <span>Experience</span>
                              <span> <ExperienceText /> </span>
                            </div>
                          ) : (
                            ""
                        )}
{/* 
                        {jobsDetail.experience_type == "N" ? (
                            <div className="flex flex-col md:flex-row justify-between">
                              <span>Experience Type</span><span>No Experience</span>
                            </div>
                          ) : jobsDetail.experience_type == "F" ? (
                            <div className="flex flex-col md:flex-row justify-between">
                              <span>Experience Type</span> <span>Fresher</span>
                            </div>
                          ) : jobsDetail.experience_type == "E" ? (
                            <div className="flex flex-col md:flex-row justify-between">
                              <span>Experience Type</span> 
                              <span>
                                {jobsDetail.min_exp} 
                                {jobsDetail.min_exp_unit === jobsDetail.exp_unit 
                                  ?  `- ${jobsDetail.max_exp}${jobsDetail.exp_unit}`
                                  : ` ${jobsDetail.min_exp_unit ? jobsDetail.min_exp_unit : ""} - ${jobsDetail.max_exp} ${jobsDetail.exp_unit}`
                                }
                              </span>
                            </div>
                          ) : (
                            ""
                          )} */}

                          {jobsDetail.joblevel != null ? (
                              <div className="flex flex-col md:flex-row justify-between">
                                <span>Job Level</span>
                                <span>{jobsDetail.joblevel}</span> 
                              </div>
                            ) : (
                            ""
                          )}
                          {jobsDetail.job_type != null ? (
                              <div className="flex flex-col md:flex-row justify-between">
                                <span>Job Type</span>
                                <span>{jobsDetail.job_type}</span>
                              </div>
                            ) : (
                            ""
                          )}
                          {jobsDetail.gender != null ? (
                              <div className="flex flex-col md:flex-row justify-between">
                                <span>Gender</span>
                                <span>{jobsDetail.gender}</span>
                              </div>
                            ) : (
                            ""
                          )}
                          {jobsDetail.driving_license == "Y" ? (
                              <div className="flex flex-col md:flex-row justify-between">
                                <span> Driving License</span> 
                                <span>Yes</span>
                              </div>
                            ) : jobsDetail.driving_license == "N" ? (
                              <div className="flex flex-col md:flex-row justify-between">
                                <span>Driving License</span> 
                                <span>No</span>
                              </div>
                            ) : (
                            ""
                          )}

                          {jobsDetail.salary_type == "R" ? (
                            <div className="flex flex-col md:flex-row justify-between">
                              <span>Salary</span>
                              <span>
                                {jobsDetail.jobcur} {jobsDetail.minsalary}-
                                {jobsDetail.maxsalary} / {jobsDetail.salary_unit}
                              </span>
                            </div>
                            ) : jobsDetail.salary_type == "F" ? (
                              <div className="flex flex-col md:flex-row justify-between">
                                <span>Salary</span>
                                <span>
                                  {jobsDetail.jobcur} {jobsDetail.minsalary}/{" "}
                                  {jobsDetail.salary_unit}
                                </span>
                              </div>
                            ) : jobsDetail.salary_type == "N" ? (
                              <div className="flex flex-col md:flex-row justify-between">
                                {" "}
                                <span>Salary</span>
                                <span>Negotiable</span>
                              </div>
                            ) : (
                            ""
                          )}

                          {jobsDetail.educationlevel != "" ? (
                            <div className="flex flex-col md:flex-row justify-between">
                                <span>Education Level</span>
                                <span>
                                  {jobsDetail.educationlevel}
                                </span>
                            </div>
                            ) : (
                            ""
                          )}
                          {jobsDetail.degreename != "" ? (
                            <div className="flex flex-col md:flex-row justify-between">
                              <span>Degree</span>
                              <span>
                                {jobsDetail.degreename}
                              </span>
                            </div>
                            ) : (
                              ""
                          )}

                          <div className="flex flex-col md:flex-row justify-between">
                            {jobSkills.length > 0 && <span>Skills</span>}
                            <span>
                              {jobSkills.length > 0
                              ? jobSkills.map((skillitem, idx) => (
                                  <small className="badge badge-secondary">
                                    {skillitem.title}
                                  </small>
                                ))
                              : ""}
                            </span>
                          </div>
                          <div className="flex flex-col md:flex-row justify-between">
                            <span>Expiry Date</span>
                            <span className="twm-job-apllication-date">
                               <ExpiryText />
                            </span>
                          </div>
                          



                  </div>
                </div>

              </div>

              {jobsDetail.job_description != null ? (
                <div className="job_desc bg-gray">
                  <h4 className="twm-s-title">Job Description</h4>
                  {ReactHtmlParser(jobsDetail.job_description)}
                </div>
              ) : (
                ""
              )}
              {jobsDetail.job_specification != null ? (
                <div className="job_desc bg-gray">
                  <h4 className="twm-s-title">Job Specification</h4>
                  {ReactHtmlParser(jobsDetail.job_specification)}
                </div>
              ) : (
                ""
              )}
              {jobsDetail.education_required != null ? (
                <div className="job_desc bg-gray">
                  <h4 className="twm-s-title">
                    Required Knowledge, Skills, and Abilities
                  </h4>
                  {ReactHtmlParser(jobsDetail.education_required)}
                </div>
              ) : (
                ""
              )}
              {jobsDetail.job_benefit != null ? (
                <div className="job_desc bg-gray">
                  <h4 className="twm-s-title">Benefits</h4>
                  {ReactHtmlParser(jobsDetail.job_benefit)}
                </div>
              ) : (
                ""
              )}
              {jobsDetail.instruction != null ? (
                <div className="job_desc bg-gray">
                  <h4 className="twm-s-title">Apply Instruction</h4>
                  {ReactHtmlParser(jobsDetail.instruction)}
                </div>
              ) : (
                ""
              )}

              {/* {!isAuthenticated && jobsDetail.apply_online == 'Y' && jobsDetail.daysDifference >= 0 ? (
                <div className="twm-job-self-bottom">
                  <Link to="/login" className="site-button">
                    Apply Now
                  </Link>
                </div>
              ) : null}
              {isAuthenticated &&
              userType == "seeker" &&
              jobsDetail.apply_online == 'Y' &&
              jobsDetail.daysDifference >= 0 ? (
                hasApplied ? (
                  <div className="twm-job-self-bottom">
                    <Link
                      to="/profile?tab=appliedJobs"
                      className="btn btn-outline-success"
                    >
                      Already Applied
                    </Link>
                  </div>
                ) : (
                  <div className="twm-job-self-bottom">
                    <a
                      href="javascript:;"
                      onClick={handleJobApply}
                      className="site-button"
                    >
                      Apply Now
                    </a>
                  </div>
                )
              ) : null} */}



              <div className="job_apply_sec">

                  {!isAuthenticated ? (
                    <div className="job-save-btn">
                      <Link to="/login" className="btn btn-primary">
                        <i className="ri ri-save-line"></i> Bookmark Job
                      </Link>
                    </div>
                  ) : null}

                  {!isAuthenticated && jobsDetail.apply_direct== 'Y' && jobsDetail.daysDifference >= 0 ? (
                    <div className="job-email-apply-btn">
                      <Link
                        to="#easy_apply_popup"
                        className="btn btn-outline-primary"
                        data-bs-toggle="modal"
                      >
                        <i className="ri ri-mail-line"></i> Easy Apply
                      </Link>
                    </div>
                  ) : !isAuthenticated && jobsDetail.daysDifference < 0 ? (
                    <div className="job-email-apply-btn">
                      <button className="btn btn-danger">Expired</button>
                    </div>
                  ) : null}
                  {isAuthenticated &&
                  userType == "seeker" &&
                  jobsDetail.apply_direct== 'Y' &&
                  jobsDetail.daysDifference >= 0 ? (
                    <div className="job-email-apply-btn">
                      <Link
                        to="#easy_apply_popup"
                        className="btn btn-outline-primary"
                        data-bs-toggle="modal"
                      >
                        <i className="ri ri-mail-line"></i> Easy Apply
                      </Link>
                    </div>
                  ) : isAuthenticated &&
                    userType == "seeker" &&
                    jobsDetail.daysDifference < 0 ? (
                    <div className="job-email-apply-btn">
                      <button className="btn btn-danger">Expired</button>
                    </div>
                  ) : null}

                  {isAuthenticated && userType == "seeker" ? (
                    hasSaved ? (
                      <div className="job-save-btn">
                        <Link
                          to="/profile?tab=savedJobs"
                          className="btn btn-primary"
                        >
                          <i className="ri ri-save-line"></i> Already Saved
                        </Link>
                      </div>
                    ) : (
                      <div className="job-save-btn">
                        <button
                          type="button"
                          onClick={handleJobSave}
                          className="btn btn-primary"
                          disabled={saving}
                        >
                          <i className="ri ri-save-line"></i> {saving ? "Saving..." : "Bookmark Job"}
                        </button>
                      </div>
                    )
                  ) : null}

                  {!isAuthenticated && jobsDetail.apply_online == 'Y' && jobsDetail.daysDifference >= 0 ? (
                    <div className="twm-job-self-bottom">
                      <Link to="/login" className="site-button">
                        <i className="ri ri-send-plane-line"></i> Apply Now
                      </Link>
                    </div>
                  ) : null}
                  {isAuthenticated &&
                  userType == "seeker" &&
                  jobsDetail.apply_online == 'Y' &&
                  jobsDetail.daysDifference >= 0 ? (
                    hasApplied ? (
                      <div className="twm-job-self-bottom">
                        <Link
                          to="/profile?tab=appliedJobs"
                          className="btn btn-outline-success"
                        >
                          <i className="ri ri-send-plane-line"></i> Already Applied
                        </Link>
                      </div>
                    ) : (
                      <div className="twm-job-self-bottom">
                        <button
                          type="button"
                          onClick={handleJobApply}
                          className="site-button"
                          disabled={applying}
                        >
                          <i className="ri ri-send-plane-line"></i> {applying ? "Applying..." : "Apply Now"}
                        </button>
                      </div>
                    )
                  ) : null}

              </div>

              

              {/* <h4 className="twm-s-title">Location</h4>
              <div className="twm-m-map mb-5">
                <div className="twm-m-map-iframe">
                  <iframe
                    height="310"
                    src="https://maps.google.com/maps?q=DishHome%20FiberNet%20bagbazar&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  ></iframe>
                </div>
              </div> */}

              
            </div>
          </div>
          
          <div className="col-xl-4 col-lg-4 col-md-12">
            <div className="related_jobs">
                <h4 className="twm-s-title mt-0 text-left">Related Jobs</h4>
            {/* <button
              onClick={handleNextClick}
              className="sf-relatedjobs-arrow-btn sf-arrow-left"
              aria-label="Previous testimonials"
              type="button"
            >
              <i className="fa fa-chevron-up"></i>
            </button> */}
              { similarjobs.length > 0 ? 
              (
              <>
                    <button
                      onClick={handleNextClick}
                      className="sf-relatedjobs-arrow-btn sf-arrow-left"
                      aria-label="Previous testimonials"
                      type="button"
                    >
                      <i className="fa fa-chevron-up"></i>
                    </button>
                  <VerticalMode ref={sliderRef} vsettings={vsettings}>
                    {similarjobs.map((job) => (
                      <RelatedJobsCard key={job.id} job={job} />
                    ))}
                  </VerticalMode>
                    <button
                      onClick={handlePrevClick}
                      className="sf-relatedjobs-arrow-btn sf-arrow-right"
                      aria-label="Next testimonials"
                      type="button"
                    >
                      <i className="fa fa-chevron-down"></i>
                    </button>

              </>
              ) 
              
              : (
                <div className="sf-empty">No jobs in this category.</div>
              )}
            {/* <button
              onClick={handlePrevClick}
              className="sf-relatedjobs-arrow-btn sf-arrow-right"
              aria-label="Next testimonials"
              type="button"
            >
              <i className="fa fa-chevron-down"></i>
            </button> */}
            </div>


              {/* <div className="clearfix"></div> */}


            {sameCompanyJobs.length > 0 ? (
                <div>
                  
                    
                  {/* <div className="related_jobstwm-jobs-list-wrap"> */}
                  <div className="related_jobs">
                    <h4 className="twm-s-title mt-0 text-left">More Jobs at This Company</h4>
                    
                    <div className="row">

                      {sameCompanyJobs.length > 0
                        ? sameCompanyJobs.map((scj) => (
                    <div
                      className="col-lg-12 col-md-12 m-b10"
                      key={generateRandomString(8)}
                    >
                      <RelatedJobsCard key={scj.id} job={scj} />

                    </div>
                          ))
                        : ""}

                      <div className="clearfix"></div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

            {/* <div className="twm-advertisment">
              <div className="overlay"></div>
              <h4 className="twm-title">Recruiting?</h4>
              <p>
                Get Best Matched Jobs On your Email. <br />
                Add Resume NOW !{" "}
              </p>
              <Link to="/" className="site-button white">
                Read More
              </Link>
            </div>
            <div className="bigyapan">
              <Link to="/">
                <figure>
                  <img src="portal/images/interniship.png" alt="#" />
                </figure>
              </Link>
            </div> */}

          </div>

          <div className="clearfix"></div>
        </div>
      </div>

      <EmailApplyModal jobid={jobsDetail.id} />
    </div>
  );
}
